const axios = require("axios");

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

export const getTopGoals = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `topGoals?noOfDays=${noOfDays}&limit=5`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const getAllGoals = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `topGoals?noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const goalStats = async (noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `goalStats?noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};
 
export const goalDetails = async (id, type, limit, offset, noOfDays) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `goals/${id}/conversions?type=${true}&limit=${limit}&offset=${offset}&noOfDays=${noOfDays}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};
export const getGraphCJ = async (noOfDays , id)=>{
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + (!id ? `customerJourney?noOfDays=${noOfDays}` : `customerJourney?noOfDays=${noOfDays}&type=single&goalId=${id}`),
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
    }
//   return [
//              {     level:1,
//                    nodes : [

//                                  {   'id' :'1',
//                                 "nodeLabel": "Facebook",
//                                 "nodeWeight": 20,
//                                 "color":'blue',
//                                 "edges": [
//                                     {
//                                         "nodeId": "6",
//                                         "edgeWeight": 40
//                                     }
//                                     , {
//                                         "nodeId": "7",
//                                         "edgeWeight": 10
//                                     }
//                                 ],},
//                                 {
//                                     'id': '2',
//                                     "nodeLabel": "Facebook",
//                                     "nodeWeight": 20,
//                                     "color": 'blue',
//                                     "edges": [
//                                         {
//                                             "nodeId": "7",
//                                             "edgeWeight": 20
//                                         }
//                                     ],
//                                 },
//                                {
//                                     'id': '3',
//                                     "nodeLabel": "Facebook",
//                                     "nodeWeight": 20,
//                                    "color": 'blue',
//                                     "edges": [
//                                         {
//                                             "nodeId": "8",
//                                             "edgeWeight": 90
//                                         }
//                                     ],
//                                 },
//                                 {
//                                     'id': '4',
//                                     "nodeLabel": "Facebook",
//                                     "nodeWeight": 20,
//                                     "color": 'red',
//                                     "edges": [
//                                         {
//                                             "nodeId": "8",
//                                             "edgeWeight": 40
//                                         }
//                                     ],
//                                 },
//                                 {
//                                     'id': '5',
//                                     "nodeLabel": "Facebook",
//                                     "nodeWeight": 20,
//                                     "color": 'green',
//                                     "edges": [
//                                         {
//                                             "nodeId": "6",
//                                             "edgeWeight": 50
//                                         }
//                                     ],
//                                 },
//                    ]
//              },
//       {
//           level: 2,
//           nodes: [

//               {
//                   'id': '6',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'orange',
//                   "edges": [
//                       {
//                           "nodeId": "11",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//               {
//                   'id': '7',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "11",
//                           "edgeWeight": 50
//                       }
//                   ],
//               },
//               {
//                   'id': '8',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'yellow',
//                   "edges": [
//                       {
//                           "nodeId": "12",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//               {
//                   'id': '9',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'aliceblue',
//                   "edges": [
//                       {
//                           "nodeId": "13",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
 
//           ]
//       },
//       {
//           level: 3,
//           nodes: [

//               {
//                   'id': '11',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "17",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//               {
//                   'id': '12',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "16",
//                           "edgeWeight": 90
//                       }
//                   ],
//               },
//               {
//                   'id': '13',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "16",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//               {
//                   'id': '14',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "17",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//               {
//                   'id': '15',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
//                       {
//                           "nodeId": "16",
//                           "edgeWeight": 20
//                       }
//                   ],
//               },
//           ]
//       },
//       {
//           level: 4,
//           nodes: [

//               {
//                   'id': '16',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
          
//                   ],
//               },
//               {
//                   'id': '17',
//                   "nodeLabel": "Facebook",
//                   "nodeWeight": 20,
//                   "color": 'red',
//                   "edges": [
              
//                   ],
//               },
   

//           ]
//       },

//          ]
// }